import Chip from '@material-ui/core/Chip';
import useStyles from './styles';

export const SearchUsageChip = ({ usage }) => {
  const classes = useStyles();

  if (!usage) return null;
  return <Chip label={usage} className={classes.chip} />;
};
